import { Skeleton } from '@mui/material';
import { useTagById } from 'features/tags';
import { useIsFavorite, useToggleFavorite } from 'features/user';
import { ViewContextMenu } from 'pages/tag-detail/components/header-interactions/view-context-menu';
import React, { useRef } from 'react';
import { useParams } from 'react-router';
import { MenuDotsCircle18, SettingsSort18, Star18 } from 'shared/assets/icons';
import { TagContextMenu } from 'shared/components/connected/tag-context-menu';
import { IconButton, Sizes, Variants } from 'shared/components/ui/icon-button';
import { useOpenMenu } from 'shared/hooks/use-open-menu';
import { FavoriteType } from 'shared/types/user-settings';

import * as Styled from './page-top-bar.style';

export const LoadingInteractions: React.FC = () => (
  <Skeleton animation="wave" width="6.4rem" height="3.2rem" />
);

export const Interactions: React.FC = () => {
  const interactionsRef = useRef<HTMLDivElement>(null);
  const viewButtonRef = useRef<HTMLButtonElement>(null);
  const moreRef = useRef<HTMLButtonElement>(null);

  const { id } = useParams();
  const isFavorite = useIsFavorite(id);
  const tag = useTagById(id);

  const {
    menuOpen: settingsMenuOpen,
    openMenu: openSettingsMenu,
    closeMenu: closeSettingsMenu,
  } = useOpenMenu();
  const { menuOpen, openMenu, closeMenu } = useOpenMenu();
  const toggleFavorite = useToggleFavorite();

  const onFavorite = () => tag && toggleFavorite(tag.id, FavoriteType.Tag);

  return (
    <Styled.Interactions ref={interactionsRef}>
      <Styled.FavoriteButtonContainer $isFavorite={isFavorite}>
        <IconButton
          icon={Star18}
          size={Sizes.Large}
          onClick={onFavorite}
          preventDrag
        />
      </Styled.FavoriteButtonContainer>

      <IconButton
        ref={viewButtonRef}
        icon={SettingsSort18}
        onClick={openMenu}
        variant={Variants.Contained}
        preventDrag
      />

      <IconButton
        ref={moreRef}
        icon={MenuDotsCircle18}
        onClick={openSettingsMenu}
        preventDrag
      />

      {menuOpen && (
        <ViewContextMenu
          onClose={closeMenu}
          referenceElement={viewButtonRef}
          tagId={id}
        />
      )}

      {settingsMenuOpen && (
        <TagContextMenu
          id={id!}
          onClose={closeSettingsMenu}
          referenceElement={moreRef}
        />
      )}
    </Styled.Interactions>
  );
};
